import styled from 'styled-components';

/* Wrapper that supports position:relative so that absolutely-positioned
   children (floating search bar in map view, filter buttons) remain visible */
export const PanelRelativeWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: visible;
`;
